(function () {
  if (window.__nestNewsletterPopupKeyboardFocus20260702) return;
  window.__nestNewsletterPopupKeyboardFocus20260702 = true;

  var popupSelector = '#ouibounce-modal.newsletter-popup-container';
  var dialogSelector = '#ouibounce-popup, #ouibounce-modal .newsletter-popup';
  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');
  var lastFocused = null;

  function isVisible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      element.getClientRects().length > 0;
  }

  function visiblePopup() {
    var popup = document.querySelector(popupSelector);
    if (!popup || !popup.classList.contains('is-visible') || !isVisible(popup)) return null;
    return popup;
  }

  function dialogFor(popup) {
    return popup.querySelector(dialogSelector) || popup;
  }

  function focusablesFor(popup) {
    return Array.prototype.slice.call(popup.querySelectorAll(focusableSelector)).filter(isVisible);
  }

  function makeControlsFocusable(popup) {
    var close = popup.querySelector('#ouibounce-popup-close-icon, .newsletter-popup__close');
    if (close) {
      if (close.tagName.toLowerCase() !== 'button') close.setAttribute('role', 'button');
      close.setAttribute('tabindex', '0');
      if (!close.getAttribute('aria-label')) close.setAttribute('aria-label', 'Close newsletter popup');
    }

    var dialog = dialogFor(popup);
    if (!dialog.getAttribute('role')) dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    if (!dialog.getAttribute('tabindex')) dialog.setAttribute('tabindex', '-1');
  }

  function moveFocusInto(popup) {
    makeControlsFocusable(popup);
    var focusables = focusablesFor(popup);
    var target = popup.querySelector('#ouibounce-popup-close-icon, .newsletter-popup__close') ||
      focusables[0] ||
      dialogFor(popup);

    if (target && typeof target.focus === 'function') {
      try {
        target.focus({ preventScroll: true });
      } catch (error) {
        target.focus();
      }
    }
  }

  function closePopup(popup) {
    var close = popup.querySelector('#ouibounce-popup-close-icon, .newsletter-popup__close, .newsletter-close-link');
    if (close && typeof close.click === 'function') {
      close.click();
      return;
    }
    popup.classList.remove('is-visible');
    popup.classList.add('is-dismissed');
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener('keydown', function (event) {
    var popup = visiblePopup();
    if (!popup) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closePopup(popup);
      return;
    }

    if (event.key === 'Enter') {
      var close = event.target && event.target.closest ? event.target.closest('#ouibounce-popup-close-icon, .newsletter-popup__close, .newsletter-close-link') : null;
      if (close) {
        event.preventDefault();
        close.click();
      }
      return;
    }

    if (event.key !== 'Tab') return;

    makeControlsFocusable(popup);
    var focusables = focusablesFor(popup);
    if (!focusables.length) {
      event.preventDefault();
      moveFocusInto(popup);
      return;
    }

    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  document.addEventListener('focusin', function (event) {
    var popup = visiblePopup();
    if (!popup) return;
    if (popup.contains(event.target)) return;
    moveFocusInto(popup);
  }, true);

  function watchPopup() {
    var popup = visiblePopup();
    if (!popup) return;
    if (!popup.getAttribute('data-nest-popup-focus-ready')) {
      popup.setAttribute('data-nest-popup-focus-ready', 'true');
      lastFocused = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      window.setTimeout(function () { moveFocusInto(popup); }, 0);
      window.setTimeout(function () { moveFocusInto(popup); }, 150);
    }
  }

  function restoreFocusIfClosed() {
    var popup = document.querySelector(popupSelector);
    if (popup && popup.classList.contains('is-visible')) return;
    if (lastFocused && lastFocused.isConnected && typeof lastFocused.focus === 'function') {
      try {
        lastFocused.focus({ preventScroll: true });
      } catch (error) {
        lastFocused.focus();
      }
    }
    lastFocused = null;
  }

  if (window.MutationObserver) {
    new MutationObserver(function () {
      watchPopup();
      restoreFocusIfClosed();
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchPopup, { once: true });
  } else {
    watchPopup();
  }
})();

(function () {
  if (window.__nestDescriptiveHomepageLinks20260702) return;
  window.__nestDescriptiveHomepageLinks20260702 = true;

  var labelsByPath = {
    '/pages/layer-renewal-faq': 'Learn more about the Lifetime Renewal Exchange',
    '/pages/financing': 'Learn more about Nest Bedding financing options',
    '/pages/what-is-the-mattress-recycling-fee': 'Learn more about the mattress recycling fee',
    '/blogs/news/how-does-nest-keep-bedding-sustainable': 'Read more about how Nest Bedding keeps bedding sustainable'
  };

  var hiddenSuffixByPath = {
    '/pages/layer-renewal-faq': ' about the Lifetime Renewal Exchange',
    '/pages/financing': ' about Nest Bedding financing options',
    '/pages/what-is-the-mattress-recycling-fee': ' about the mattress recycling fee',
    '/blogs/news/how-does-nest-keep-bedding-sustainable': ' about how Nest Bedding keeps bedding sustainable'
  };

  function normalizedPath(anchor) {
    var href = anchor && anchor.getAttribute ? anchor.getAttribute('href') : '';
    if (!href || href.charAt(0) === '#') return '';

    try {
      var url = new URL(href, window.location.origin);
      return url.pathname.replace(/\/$/, '');
    } catch (error) {
      return href.split('?')[0].replace(/\/$/, '');
    }
  }

  function isGenericLinkText(text) {
    return /^(learn more|learn more\.|read more|read more\.|read our policy|see terms)$/i.test((text || '').replace(/\s+/g, ' ').trim());
  }

  function ensureHiddenSuffix(anchor, path) {
    if (anchor.querySelector('[data-nest-descriptive-link-suffix]')) return;

    var suffix = hiddenSuffixByPath[path];
    if (!suffix) return;

    var hiddenText = document.createElement('span');
    hiddenText.className = 'visually-hidden';
    hiddenText.setAttribute('data-nest-descriptive-link-suffix', 'true');
    hiddenText.textContent = suffix;
    anchor.appendChild(hiddenText);
  }

  function applyDescriptiveLabels(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('a[href]'), function (anchor) {
      var path = normalizedPath(anchor);
      var label = labelsByPath[path];
      if (!label || !isGenericLinkText(anchor.textContent)) return;
      anchor.setAttribute('aria-label', label);
      anchor.setAttribute('data-nest-descriptive-link-label', 'true');
      ensureHiddenSuffix(anchor, path);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyDescriptiveLabels(document);
    }, { once: true });
  } else {
    applyDescriptiveLabels(document);
  }

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node && node.nodeType === 1) applyDescriptiveLabels(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
